module.exports = {
  AdAccountArchitecture: require('./AdAccountArchitecture'),
  Project: require('./Project'),
  AdAccount: require('./AdAccount'),
  AdrielCampaign: require('./AdrielCampaign'),
  Campaign: require('./Campaign'),
  AdSet: require('./AdSet'),
  Ad: require('./Ad'),
  Report: require('./Report'),
  Dimension: require('./Dimension'),
  DimensionElement: require('./DimensionElement'),
};
